.Main {
    position: fixed;
    top: 0;
    width: 100vw;
    box-sizing: border-box;
    padding: var(--space);
    display: grid;
    grid-gap: var(--space);
    grid-template-columns: minmax(0, max-content) minmax(0, max-content);
    justify-content: space-between;
    align-items: center;
    z-index: 100;
}

.IsVisible {
}

.IsOpen {
    color: var(--bg);
}

.Logo {
    font-size: 20px;
    overflow: hidden;
    z-index: 10;
}

.Logo a {
    display: inline-block;
    color: var(--fg);
    transition: transform 500ms var(--ease-out-expo);
    transform: translateY(100%);
}

.IsVisible .Logo a {
    transform: translateX(0);
}

.IsOpen .Logo a {
    color: var(--bg);
}

.Menu {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--fg);
    box-sizing: border-box;
    padding: calc(var(--large-space) * 2) var(--space) var(--large-space) var(--space);
    align-content: end;
    font-size: 10vw;
}

.Item {
    padding: 0.25em 0;
    overflow: hidden;
}

.Item a {
    color: var(--bg);
}

.Inner {
    display: inline-block;
    transition: transform 500ms var(--ease-out-expo);
    transform: translateY(100%);
}

.IsVisible .Inner {
    transform: translateX(0);
}

.IsActive .Inner {
    pointer-events: none;
    border-bottom: solid 2px currentColor;
}

.IsOpen .Menu {
    display: grid;
}

.Button {
    position: relative;
    background: none;
    border: none;
    padding: 0;
    width: 20px;
    height: 12px;
    z-index: 10;
    display: none;
}

.IsOpen .Button {
    color: var(--bg);
}

.IsVisible .Button {
    display: block;
}

.Button span {
    background: currentColor;
    position: absolute;
    left: 0;
    width: 100%;
    height: 2px;
    transform-origin: 3px 1px;
}

.Button :first-child {
    top: 0;
}

.Button :last-child {
    bottom: 0;
}

.IsOpen .Button :first-child {
    transform: rotate(45deg);
}

.IsOpen .Button :last-child {
    transform: rotate(-45deg);
}

@media (min-width: 768px) {
    .Main {
        padding: var(--small-space) var(--space);
    }
}

@media (min-width: 1024px) {
    .Main {
        position: fixed;
        padding: var(--small-space) var(--space);
    }

    .Logo {
        font-size: var(--text-size);
    }

    .Menu {
        position: static;
        align-self: end;
        display: grid;
        grid-auto-flow: column;
        grid-gap: var(--small-space);
        background: none;
        padding: 0;
        font-size: unset;
    }

    .Item {
        padding: 0;
    }

    .Item a {
        color: var(--fg);
    }

    .Inner {
        will-change: transform;
        transition: transform 500ms var(--ease-out-expo);
        transform: translateY(100%);
    }

    .IsVisible .Inner {
        transform: translateX(0);
    }

    .IsVisible .Button {
        display: none;
    }
}